import type { EstadoDeAcesso, QualidadePorEmail } from "../types";

type Estado = {
  chave: EstadoDeAcesso;
  rotulo: string;
  explicacao: string;
  cor: string;
  contagem: (linha: QualidadePorEmail) => number;
};

/**
 * Os estados na ordem em que interessam: o que exige ação da equipe primeiro.
 * O rótulo é escrito para quem opera, não para quem programa — "perdemos o
 * acesso" diz o que fazer; "SEM_ACESSO" não diz nada.
 */
export const ESTADOS: Estado[] = [
  {
    chave: "SEM_ACESSO",
    rotulo: "Perdemos o acesso",
    explicacao: "O Google não mostra mais este perfil por nenhuma conta nossa. Precisa pedir acesso de novo.",
    cor: "#c53030",
    contagem: (linha) => linha.semAcesso,
  },
  {
    chave: "ACESSO_SOLICITADO",
    rotulo: "Acesso solicitado",
    explicacao: "Já pedimos acesso e estamos aguardando o cliente aceitar.",
    cor: "#b7791f",
    contagem: (linha) => linha.acessoSolicitado,
  },
  {
    chave: "SUSPENSO",
    rotulo: "Suspenso pelo Google",
    explicacao: "O Google suspendeu a ficha. Precisa de recurso junto ao suporte do Google.",
    cor: "#dd6b20",
    contagem: (linha) => linha.suspensos,
  },
  {
    chave: "COPIA",
    rotulo: "Marcado como cópia",
    explicacao: "O Google apontou a ficha como duplicada de outra.",
    cor: "#805ad5",
    contagem: (linha) => linha.copias,
  },
  {
    chave: "COM_ACESSO",
    rotulo: "Tudo certo",
    explicacao: "Última verificação com o Google respondeu normalmente.",
    cor: "#2f855a",
    contagem: (linha) => linha.comAcesso,
  },
  {
    chave: "NAO_VERIFICADO",
    rotulo: "Ainda não verificado",
    explicacao: "Ainda não passou por uma verificação desde que começamos a registrar.",
    cor: "#718096",
    contagem: (linha) => linha.naoVerificados,
  },
];

/** Quantos perfis exigem alguma ação — o número que a equipe persegue. */
export const totalComProblema = (linha: QualidadePorEmail): number =>
  linha.semAcesso + linha.suspensos + linha.copias + linha.acessoSolicitado;

export const somar = (
  linhas: QualidadePorEmail[],
  campo: (linha: QualidadePorEmail) => number,
): number => linhas.reduce((total, linha) => total + campo(linha), 0);

/** "há 3 dias" comunica melhor que uma data ISO para quem está caçando problema. */
export const desdeQuando = (quando: string | null, agora: Date = new Date()): string => {
  if (!quando) return "sem verificação";
  const data = new Date(quando);
  if (Number.isNaN(data.getTime())) return "sem verificação";

  const dias = Math.floor((agora.getTime() - data.getTime()) / 86_400_000);
  if (dias <= 0) return "hoje";
  if (dias === 1) return "ontem";
  return `há ${dias} dias`;
};
